<template>
  <div class="select_dialog_embed" id="select_dialog_embed" :style="{'overflow-y' : (isShow ? 'hidden' : 'auto') }">
    <div class="store_link_list_embed_msg" v-if="showType !== 'redownloadLink'">
      <div class="select_dialog_embed_box">
        <!--弹出框头部-->
        <div class="select_dialog_embed_box_top">
          <p>{{title}}</p>
        </div>

        <!--弹出框信息-->
        <div class="select_dialog_embed_box_content">
          <!--查看未识别编码详情-->
          <div v-if="showType === 'cannotLinkDetail'" class="select_dialog_embed_box_handle cannot_link_detail">
            <!--表格固定头部-->
            <table class="table">
              <colgroup>
                <col style="width: 100%">
              </colgroup>
              <thead>
              <tr>
                <th>平台属性</th>
                <th class="w200">无法识别编码</th>
              </tr>
              </thead>
            </table>
            <!--表格滚动内容-->
            <table class="table">
              <colgroup>
                <col style="width: 100%">
              </colgroup>
              <tbody>
              <tr v-for="(item, index) in cannotNumDetailList.linkerrorskuInfo" :key="index">
                <td>{{item.PropsName}}</td>
                <td class="w200"><input type="text" v-model="item.OuterId"></td>
              </tr>
              </tbody>
            </table>
          </div>

        </div>

        <!--弹出框底部-->
        <div class="select_dialog_embed_box_bottom pb30">
          <button v-if="showType !== 'cannotLinkDetail'" class="btn_normal"
                  @click="submitBtn()">确定
          </button>
          <button v-if="showType === 'cannotLinkDetail'" class="btn_normal" @click="submitBtn()">同步商家编码</button>
          <button class="btn_cancel" @click="cancelBtn(false)">关闭</button>
        </div>
      </div>
    </div>

    <!--信息提示框-->
    <msg-dialog v-if="isMsg"
                :txt="txtMsg"
                :is-suc="isSuc"
                @closebtn="closeMsgDialog"></msg-dialog>

    <!--弹出判断框-->
    <baby-dialog v-if="isShow"
                 :title="dialogTitle"
                 :show-type="showType"
                 :msg="babyDialogMsg"
                 @cancelmsgbtn="getBabyDialog"></baby-dialog>
  </div>
</template>

<script type="es6">
  import MsgDialog from '../../../public-component/msg-dialog';
  import BabyDialog from './baby-dialog';

  export default {
    name: 'cannot-link-list-embed-msg',
    /**
     *  title：  头部名
     *  showType:
     *  cannotLinkMsg: 链接信息
     * */
    props: ['title', 'showType', 'cannotLinkMsg'],
    components: {MsgDialog, BabyDialog},
    data() {
      return {
        cannotNumDetailList: {
          Id: null,
          NumId: null,
          ShopId: null,
          linkerrorskuInfo: []
        }, // 未识别编码详情列表
        isShow: '', // 是否显示弹出判断框
        babyDialogMsg: null, // 传入判断框里的信息
        dialogTitle: '', // 弹出判断框头部
        isMsg: false, // 信息框显示
        isSuc: false, // 是否成功
        txtMsg: '', // 信息框内容
        time: 3, // 倒计时时间
        timer: null // 计时器
      }
    },
    methods: {
      // 查看无法识别链接详情
      getLinkErrorSkuId() {
        this.$axios.post(this.Global.getLinkErrorSkuId(this.cannotLinkMsg.Id, this.cannotLinkMsg.ShopId), null).then((res) => {
          if (!res.data.errorMsg.length) {
            this.cannotNumDetailList = res.data.resData[0];
            this.babyDialogMsg = this.cannotNumDetailList;
          } else {
            this.isMsg = true;
            this.isSuc = false;
            this.txtMsg = res.data.errorMsg;
            let timer;
            const self = this;
            timer = setTimeout(function () {
              self.cancelBtn(false);
              clearTimeout(timer);
            }, 3000);
          }
        });
      },

      // 提交按钮
      submitBtn() {
        if (this.showType === 'cannotLinkDetail') { // 同步商家编码
          // 平台无修改商家编码接口
          /* this.txtMsg = '平台不支持修改商家编码！';
          this.isMsg = true; */
          this.dialogTitle = '提示';
          this.isShow = true;
        }

        // 计时器
        if (this.isMsg) {
          this.time = 3;
          const self = this;
          this.timer = setInterval(function () {
            self.time = --self.time;
            if (self.time < 1) {
              self.isMsg = false;
              clearInterval(self.timer);
            }
          }, 1000);
        }
      },

      // 取消按钮
      cancelBtn(type) {
        this.$emit('cancelbtn', {isShow: false, handleType: type});
      },

      // 获取弹出判断框方法返回参数 -- 嵌入弹出框
      getBabyDialog(e) {
        this.isShow = e.showType;
        if (e.handleType) {
          this.cancelBtn(true);
        }
      },

      // 接收提示框传送的数据
      closeMsgDialog(e) {
        this.isMsg = e;
      }
    },
    created() {
      if (this.showType === 'redownloadLink') {
        this.dialogTitle = '提示';
        this.isShow = true;
      } else if (this.showType === 'cannotLinkDetail') {
        this.getLinkErrorSkuId();
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../../../assets/css/home-view";

  .store_link_list baby_manage_tabs {
    overflow-y: hidden!important;
  }

  .select_dialog_embed {
    .store_link_list_embed_msg {
      /*width: min-content;*/
      /*max-width: 75%;*/
      /*min-width: 380px;*/
      max-width: 730px;
      /*width: min-content;*/
      /*width: max-content;*/
      max-height: 100%;

      .select_dialog_embed_box {
        width: 100%;
        min-width: min-content;

        .select_dialog_embed_box_handle {
          width: 100%;
          margin-top: 10px;

          &.cannot_link_detail {
            .table {
              width: 98%;
              margin: 10px auto;

              &:nth-child(1) {
                margin-bottom: 0;
                border-bottom: none;

                th {
                  border-bottom: none;
                }
              }

              &:nth-child(2) {
                margin-top: 0;
                border-top: none;
              }

              thead, tbody tr {
                display: table;
                width: 100%;
                table-layout: fixed;
              }

              tbody {
                display: block;
                width: 100%;
                max-height: 450px;
                overflow-y: auto;

                &::-webkit-scrollbar {
                  display: none;
                }
              }

              th, td {
                /* border: 1px solid $bgC; */
                border-top: 1px solid #eee;

                &:nth-child(1) {
                  border-right: 1px solid $bgC;
                }

               /* &:nth-child(2) {
                  border-right: none;
                }*/
              }
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/home/goods-management/baby-management/cannot-link-list-embed-msg.vue